import {
    Component,
    ComponentFactoryResolver,
    ElementRef,
    Inject,
    Injector,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';

import { TranslationKeyMap } from '../../../event-centre-c-pop-dialog.i18n';
import { CMPS_EC_SWITCH_CONTEXT } from '../../../model/metadata';
import { SwitchContext } from '../../../model/switch-context.model';
import { deflateElements, inflateElements } from '../../../template-inflater';

@Component({
    selector: 'cmps-event-centre-c-pop-base-v1',
    templateUrl: './base-v1.component.html',
    host: {
        class: 'cmps-event-centre-c-pop-base-v1',
    },
})
export class BaseV1Component implements OnInit, OnDestroy {
    /** @private */
    _i18n = TranslationKeyMap;

    @ViewChild('containerRef', { read: ElementRef, static: true })
    private readonly _containerRef: ElementRef<HTMLElement>;

    @ViewChild('ref', { read: ViewContainerRef, static: true })
    private readonly _ref: ViewContainerRef;

    constructor(
        private readonly _injector: Injector,
        private readonly _factoryResolver: ComponentFactoryResolver,
        /** @private */ @Inject(CMPS_EC_SWITCH_CONTEXT)
        readonly _data: SwitchContext,
    ) {}

    ngOnInit(): void {
        inflateElements(
            this._injector,
            this._factoryResolver,
            this._containerRef,
            this._ref,
            this._data,
        );
    }

    ngOnDestroy(): void {
        deflateElements(this._ref);
    }
}
